import { useSelector } from 'react-redux';

import { useCompanySettingsQuery } from 'theSource/queries';
import { ChatBotWrapperStyled } from './ChatBotStyled';
import { buildChatBotModal } from 'theSource/components/Chatbot/chatbot';
import { selectIsAdmin } from 'theSource/features';
import DesktopChatbotIcon from 'assets/chatbot-desktop-icon.svg';
import MobileChatbotIcon from 'assets/chatbot-mobile-icon.svg';
// import './chatbot.css';

type CardButtonProps = {
  renderDefault?: boolean;
  useDesktopIcon?: boolean;
  showText?: boolean;
  enrollment?: boolean;
};

export function ChatBot({
  useDesktopIcon = false,
  renderDefault = true,
  showText = true,
  enrollment = false,
}: CardButtonProps) {
  const { companySettings } = useCompanySettingsQuery({ enabled: true });
  const isAdmin = useSelector(selectIsAdmin);

  const showChatBot = companySettings && companySettings.data.chat_bot;
  const isMobile = window.innerWidth < 744;
  function handleChatBotClick() {
    buildChatBotModal(undefined, enrollment);
    if (isMobile) {
      const overlayDiv = document.createElement('div');
      overlayDiv.className = 'chatbot-overlay';
      document.body.prepend(overlayDiv);
      setTimeout(() => {
        document.body.classList.add('chatbot-open');
      }, 1000);
    }
  }

  let chatbotIcon = DesktopChatbotIcon;
  chatbotIcon =
    window.innerWidth < 1200 && !useDesktopIcon
      ? MobileChatbotIcon
      : DesktopChatbotIcon;

  if (showChatBot && !isAdmin) {
    return (
      <ChatBotWrapperStyled
        id="chatbot-wrapper"
        className={
          enrollment
            ? 'chat-enrollment-location'
            : renderDefault
              ? 'chat-default-location'
              : ''
        }
      >
        {showText && (
          <div className="icon initial-modal">
            <span className="emoji mr-2">👋</span>
            {renderDefault ? 'Need Help?' : 'Olive, your AI assistant.'}
          </div>
        )}
        <div className="home-icon icon">
          <button
            id="chatbot-icon"
            aria-label="talk to Olive Ai"
            onClick={handleChatBotClick}
          >
            <img
              src={chatbotIcon}
              alt="chatbot Icon"
              className="mr-2 mb-0"
              height="100%"
            />
          </button>
        </div>
      </ChatBotWrapperStyled>
    );
  }
}
